import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Accordion, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faInr, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import filterService from "../../services/filter-service";
import LoginForm from "./LoginForm";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Pagination } from "swiper/modules";
import { useLocation } from "react-router-dom";
import noImage from "../../assets/images/no-image.png";
const ServiceCard = ({ service }) => {
  const location = useLocation();
  console.log(service, "service");
  const [show, setShow] = useState(false);
  // const handleShow = () => setShow(true);
  // const handleClose = () => setShow(false);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const isAuthenticated = () => {
    const accessToken = document.cookie
      .split("; ")
      .find((row) => row.startsWith("accessToken="));
    return accessToken && tokenIsValid(accessToken.split("=")[1]);
  };

  const tokenIsValid = (token) => {
    return !!token;
  };

  const handleBookNow = async () => {
    setLoading(true);
    setShow(false);
    try {
      await filterService.bookNowServices(service.id);
      if (isAuthenticated()) {
        navigate(`/book-service/${service.id}`, {
          state: {
            name: service.serviceName,
            workType: service.workTypeName,
            amount: service.amount,
            subCategoryName: service.subCategoryName,
          },
        });
      } else {
        setShowLoginModal(true);
        console.error("Booking failed!");
      }
    } catch (error) {
      console.error("Error booking service:", error);
    } finally {
      setLoading(false);
    }
  };
  const formattedServiceName = service.serviceName
    .toLowerCase()
    .replace(/ /g, "-");
  const handleShowModal = () => {
    setShow(true);
    navigate(
      `/services/${formattedServiceName}/${service.id}${location.search}`,
      {
        replace: false,
      }
    );
  };
  const handleClose = () => {
    setShow(false);
    navigate(`/services${location.search}`, {
      replace: false,
    });
  };

  useEffect(() => {
    if (id && id.toString() === service.id.toString()) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [id, service.id]);

  return (
    <div
      className="services-card-single cursor-ponter"
      onClick={(e) => {
        if (!show) handleShowModal();
      }}
    >
      <div className="image">
        <img
          src={service.serviceImage ? service.serviceImage : noImage}
          alt={service.serviceName}
        />
      </div>
      <div className="services-info">
        <div className="share-detail">
          <div className="share-detail-inner">
            <Link
              className="icon"
              onClick={(e) => {
                e.stopPropagation();

                const formattedServiceName = service.serviceName
                  .toLowerCase()
                  .replace(/ /g, "-");
                handleShowModal();
                const serviceUrl = `${window.location.origin}/services/${formattedServiceName}/${service.id}`;
                const message = `*${service.serviceName}\n\n${serviceUrl}`;
                const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
                  message
                )}`;
                window.open(whatsappUrl, "_blank");
              }}
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>Share</span>
            </Link>
          </div>
        </div>
        <div className="title">
          <h5>{service.serviceName}</h5>

          {service.rating !== undefined && (
            <div className="rating">
              <div className="rating-icon">
                {[...Array(5)].map((_, i) => (
                  <FontAwesomeIcon
                    key={i}
                    icon={faStar}
                    className={
                      i < service.rating
                        ? "text-warning"
                        : "text-warning text-muted"
                    }
                  />
                ))}
              </div>
              <div className="rating-text">{service.rating} Rating </div>
            </div>
          )}
        </div>
        <div className="service-price">
          {service.amount > 0 && (
            <>
              <FontAwesomeIcon icon={faInr} />
              <span>
                {service.amount} <sup>*</sup> <sub>(Minimum Charges)</sub>
              </span>
            </>
          )}
        </div>
        <div className="service-name">
          <span className="fw-semibold">{service.workTypeName}</span> -{" "}
          {service.subCategoryName}
        </div>
        <div className="service-meta-info">
          <p>{service.shortDesc}</p>
          <div className="view-more">
            <button className="text-btn">View More</button>
          </div>

          {/* Book Now Button */}
          <div className="d-flex justify-content-end mt-3">
            <button
              className="book-now btn orange-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleBookNow();
              }}
              disabled={loading}
            >
              {loading ? "Processing..." : "Enquiry Now"}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
            </button>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        className="service-popup"
        size="lg"
      >
        <div onClick={(e) => e.stopPropagation()}>
          <Modal.Header closeButton>
            {/* <h2 className="mb-0">
                  {service.categoryName}: {service.subCategoryName}
                </h2> */}
          </Modal.Header>
          <Modal.Body>
            <div className="service-intro">
              <div className="top-content">
                <div className="left-content">
                  <img
                    src={service.serviceImage ? service.serviceImage : noImage}
                    alt={service.serviceName}
                  />
                </div>
                <div className="right-content">
                  <h5>{service.serviceName}</h5>
                  <div className="whatsapp-share-detail">
                    <div className="whatsapp-share-detail-inner">
                      <Link
                        className="icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          const formattedServiceName = service.serviceName
                            .toLowerCase()
                            .replace(/ /g, "-");
                          handleShowModal();
                          const serviceUrl = `${window.location.origin}/services/${formattedServiceName}/${service.id}`;
                          const message = `*${service.serviceName}\n\n${serviceUrl}`;
                          const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
                            message
                          )}`;
                          window.open(whatsappUrl, "_blank");
                        }}
                      >
                        <FontAwesomeIcon icon={faWhatsapp} />
                        <span>Share</span>
                      </Link>
                    </div>
                  </div>

                  {service.rating !== undefined && (
                    <div className="rating">
                      <div className="rating-icon">
                        {[...Array(5)].map((_, i) => (
                          <FontAwesomeIcon
                            key={i}
                            icon={faStar}
                            className={
                              i < service.rating
                                ? "text-warning"
                                : "text-warning text-muted"
                            }
                          />
                        ))}
                      </div>
                      <div className="rating-text">
                        {service.rating} Rating{" "}
                      </div>
                    </div>
                  )}
                  <div className="service-price">
                    {service.amount > 0 && (
                      <>
                        <FontAwesomeIcon icon={faInr} />
                        <span>
                          {service.amount} <sup>*</sup>{" "}
                          <sub>(Minimum Charges)</sub>
                        </span>
                      </>
                    )}
                  </div>
                  <div className="work-type">
                    <b>Work Type : </b>
                    {service.workTypeName}/<span>{service.categoryName}</span>
                  </div>
                  <div className="short-description">{service.shortDesc}</div>
                </div>
              </div>
            </div>

            <div
              className="modal-content"
              dangerouslySetInnerHTML={{
                __html: service.serviceDesc,
              }}
            >
              {/* <p>{service.serviceDesc}</p> */}
            </div>
            <div className="service-faq">
              <h3>Frequently asked questions</h3>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>How do I book a service?</Accordion.Header>
                  <Accordion.Body>
                    Log in to your account, browse services (e.g., plumbing,
                    pest control, housekeeping), choose what you need, and
                    complete your booking online.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Can I choose the vendor I want?
                  </Accordion.Header>
                  <Accordion.Body>
                    Vendors are auto-assigned based on availability, service
                    area, and previous ratings. If you have special requests,
                    contact support.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Can I reschedule or cancel a service?
                  </Accordion.Header>
                  <Accordion.Body>
                    Yes, you can reschedule or cancel before the vendor is
                    dispatched. Cancellation after dispatch may not be eligible
                    for a refund.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            <div className="client-review-section">
              <h3> All Customer Reviews</h3>

              <Swiper
                className="testimonial-slider"
                slidesPerView={1}
                spaceBetween={24}
                autoplay={true}
                modules={[Pagination]}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  991: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                  },
                  1200: {
                    slidesPerView: 1.9,
                    spaceBetween: 24,
                  },
                }}
              >
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">
                            Joshua Sathyaraj
                          </span>
                        </div>
                        <div class="review-date">Apr 29, 2025</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        Executive was so professional, he took all the
                        pre-measures and checks before the cleaning. At the end
                        A/C has been cleaned so well. His service was best,
                        smooth and clean.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">
                            Chandrayee Chaudhuri.
                          </span>
                        </div>
                        <div class="review-date">Apr 29, 2025</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        Excellent AC servicing! The person was professional,
                        efficient, and did a fantastic job. Not only did they
                        service the AC thoroughly, but they also cleaned up the
                        place very nicely afterward. Truly impressed with their
                        work and attention to detail. Highly recommended!
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">
                            Spandan Bhattacharyya
                          </span>
                        </div>
                        <div class="review-date">Apr 28, 2025</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        Very professional work from Prajapati and his
                        fellowmate. They identified the issue within few seconds
                        and told about the actual problem which is being faced.
                        And perform their work accordingly. Would strongly
                        recommend others to take his service.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">Sonali Bose</span>
                        </div>
                        <div class="review-date">02/24/25</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        The work done by this professional was excellent however
                        I would like to give feedback about the previous
                        professional sent Jiarul was not at all happy , but this
                        time the ac is working fine
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="reviews-carousel-card">
                    <div class="reviews-carousel-reviewer-info-container">
                      <div class="reviews-carousel-card-reviewer-info-container">
                        <div class="reviewer-info">
                          <span class="reviewer-display-name">Deepak M.</span>
                        </div>
                        <div class="review-date">02/24/25</div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-star-rating-shop-badge-container">
                      <div class="yotpo-star-ratings">
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div class="yotpo-star-container">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-carousel-card-review-content-container">
                      <p class="review-content" tabindex="-1">
                        Sarathi's service was very nice and he did everything in
                        a detailed manner. He even cleaned the floor after the
                        service. Would prefer him for future services.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="book-now btn orange-btn"
              onClick={handleBookNow}
              disabled={loading}
            >
              {loading ? "Processing..." : "Enquiry Now"}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
            </button>
          </Modal.Footer>
        </div>
      </Modal>
      <Modal
        className="login-form"
        show={showLoginModal}
        onHide={() => setShowLoginModal(false)}
      >
        <div onClick={(e) => e.stopPropagation()}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <LoginForm onLoginSuccess={handleBookNow} LoginFrom="Popup" />
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
};

export default ServiceCard;
